/**
 * settings page for react module.
 */
/* eslint-env jquery */
import WPSPBlockIcons from '@Controls/block-icons';
import { __ } from '@wordpress/i18n';
import TypographyControl from '@Components/typography';
import WebfontLoader from '@Components/typography/fontloader';
import {
	AlignmentToolbar,
	BlockControls,
	ColorPalette,
	InspectorControls,
} from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	RangeControl,
	TabPanel,
	ToggleControl,
	TextControl,
	Button,
	ButtonGroup,
} from '@wordpress/components';

/* eslint-disable no-unused-vars */
let imageSizeOptions = [
	{ value: 'thumbnail', label: __('Thumbnail') },
	{ value: 'medium', label: __('Medium') },
	{ value: 'full', label: __('Large') },
];

const Settings = (props) => {
	props = props.parentProps;

	const { className, setAttributes, attributes } = props;

	// Setup the attributes.
	const {
		headingAlign,
		headingColor,
		subHeadingColor,
		headingTag,
		headFontSize,
		headFontSizeType,
		headFontSizeTablet,
		headFontSizeMobile,
		headFontFamily,
		headFontWeight,
		headFontSubset,
		headLineHeightType,
		headLineHeight,
		headLineHeightTablet,
		headLineHeightMobile,
		headLoadGoogleFonts,
		subHeadFontSize,
		subHeadFontSizeType,
		subHeadFontSizeTablet,
		subHeadFontSizeMobile,
		subHeadFontFamily,
		subHeadFontWeight,
		subHeadFontSubset,
		subHeadLineHeightType,
		subHeadLineHeight,
		subHeadLineHeightTablet,
		subHeadLineHeightMobile,
		subHeadLoadGoogleFonts,
		separatorWidthType,
		seperatorSpace,
		headSpace,
		subHeadSpace,
		iconimgPosition,
		iconimgBorderRadius,
		sourceType,
		seperatorPosition,
		seperatorStyle,
		seperatorWidth,
		seperatorColor,
		seperatorThickness,
		ctaType,
		ctaText,
		ctaLink,
		ctaTarget,
		ctaLinkColor,
		ctaFontSize,
		ctaFontSizeType,
		ctaFontSizeMobile,
		ctaFontSizeTablet,
		ctaFontFamily,
		ctaFontWeight,
		ctaFontSubset,
		ctaLoadGoogleFonts,
		ctaLinkHoverColor,
		iconLeftMargin,
		iconRightMargin,
		iconTopMargin,
		iconBottomMargin,
		iconImage,
		imageWidth,
		imageWidthType,
		showTitle,
		showDesc,
	} = attributes;

	/*
	 * Event to get Image as while adding.
	 */
	const getImageSize = (sizes) => {
		const sizeArr = [];
		jQuery.each(sizes, function (index) {
			const name = index;
			const p = { value: name, label: name };
			sizeArr.push(p);
		});
		return sizeArr;
	};

	if (iconImage && iconImage.sizes) {
		imageSizeOptions = getImageSize(iconImage.sizes);
	}

	let loadSubHeadGoogleFonts;
	let loadCtaGoogleFonts;
	let loadHeadGoogleFonts;

	if (headLoadGoogleFonts === true) {
		const headconfig = {
			google: {
				families: [
					headFontFamily +
						(headFontWeight ? ':' + headFontWeight : ''),
				],
			},
		};

		loadHeadGoogleFonts = (
			<WebfontLoader config={headconfig}></WebfontLoader>
		);
	}

	if (subHeadLoadGoogleFonts === true) {
		const subHeadconfig = {
			google: {
				families: [
					subHeadFontFamily +
						(subHeadFontWeight ? ':' + subHeadFontWeight : ''),
				],
			},
		};

		loadSubHeadGoogleFonts = (
			<WebfontLoader config={subHeadconfig}></WebfontLoader>
		);
	}

	if (subHeadLoadGoogleFonts === true) {
		const ctaconfig = {
			google: {
				families: [
					ctaFontFamily + (ctaFontWeight ? ':' + ctaFontWeight : ''),
				],
			},
		};

		loadCtaGoogleFonts = <WebfontLoader config={ctaconfig}></WebfontLoader>;
	}

	// Separator settings.
	const seperatorSettings = () => {
		return (
			<PanelBody title={__('Separator')} initialOpen={false}>
				<SelectControl
					label={__('Position')}
					value={seperatorPosition}
					onChange={(value) =>
						setAttributes({ seperatorPosition: value })
					}
					options={[
						{ value: 'after_icon', label: __('After Image') },
						{ value: 'after_title', label: __('After Title') },
						{ value: 'after_desc', label: __('After Description') },
					]}
				/>
				<SelectControl
					label={__('Style')}
					value={seperatorStyle}
					onChange={(value) =>
						setAttributes({ seperatorStyle: value })
					}
					options={[
						{ value: 'none', label: __('None') },
						{ value: 'solid', label: __('Solid') },
						{ value: 'double', label: __('Double') },
						{ value: 'dashed', label: __('Dashed') },
						{ value: 'dotted', label: __('Dotted') },
					]}
				/>
				{'none' !== seperatorStyle && (
					<>
						<RangeControl
							label={__('Thickness')}
							value={seperatorThickness}
							onChange={(value) =>
								setAttributes({ seperatorThickness: value })
							}
							min={0}
							max={10}
							beforeIcon=""
							allowReset
						/>
						<ButtonGroup
							className="wpsp-size-type-field"
							aria-label={__('Size Type')}
						>
							<Button
								key={'px'}
								className="wpsp-size-btn"
								isSmall
								isPrimary={separatorWidthType === 'px'}
								aria-pressed={separatorWidthType === 'px'}
								onClick={() =>
									setAttributes({ separatorWidthType: 'px' })
								}
							>
								{'px'}
							</Button>
							<Button
								key={'%'}
								className="wpsp-size-btn"
								isSmall
								isPrimary={separatorWidthType === '%'}
								aria-pressed={separatorWidthType === '%'}
								onClick={() =>
									setAttributes({ separatorWidthType: '%' })
								}
							>
								{'%'}
							</Button>
						</ButtonGroup>
						<RangeControl
							label={__('Width')}
							value={seperatorWidth}
							onChange={(value) =>
								setAttributes({ seperatorWidth: value })
							}
							min={0}
							max={'%' === separatorWidthType ? 100 : 500}
							beforeIcon=""
							allowReset
						/>
						<p className="wpsp-setting-label">
							{__('Separator Color')}
							<span className="components-base-control__label">
								<span
									className="component-color-indicator"
									style={{ backgroundColor: seperatorColor }}
								></span>
							</span>
						</p>
						<ColorPalette
							value={seperatorColor}
							onChange={(colorValue) =>
								setAttributes({ seperatorColor: colorValue })
							}
							allowReset
						/>
					</>
				)}
			</PanelBody>
		);
	};

	// URL settings.
	const ctaSettings = () => {
		return (
			<PanelBody title={__('Add Link')} initialOpen={false}>
				<SelectControl
					label={__('Type')}
					value={ctaType}
					onChange={(value) => setAttributes({ ctaType: value })}
					options={[
						{ value: 'none', label: __('None') },
						{ value: 'text', label: __('Text') },
						{ value: 'all', label: __('Complete Box') },
					]}
				/>
				{ctaType === 'text' && (
					<>
						<TextControl
							label={__('Text')}
							value={ctaText}
							onChange={(value) =>
								setAttributes({ ctaText: value })
							}
						/>
						{ctaType === 'text' && (
							<TypographyControl
								label={__('Typography')}
								attributes={attributes}
								setAttributes={setAttributes}
								loadGoogleFonts={{
									value: ctaLoadGoogleFonts,
									label: 'ctaLoadGoogleFonts',
								}}
								fontFamily={{
									value: ctaFontFamily,
									label: 'ctaFontFamily',
								}}
								fontWeight={{
									value: ctaFontWeight,
									label: 'ctaFontWeight',
								}}
								fontSubset={{
									value: ctaFontSubset,
									label: 'ctaFontSubset',
								}}
								fontSizeType={{
									value: ctaFontSizeType,
									label: 'ctaFontSizeType',
								}}
								fontSize={{
									value: ctaFontSize,
									label: 'ctaFontSize',
								}}
								fontSizeMobile={{
									value: ctaFontSizeMobile,
									label: 'ctaFontSizeMobile',
								}}
								fontSizeTablet={{
									value: ctaFontSizeTablet,
									label: 'ctaFontSizeTablet',
								}}
								disableLineHeight={true}
							/>
						)}
					</>
				)}
				{ctaType !== 'none' && (
					<>
						<TextControl
							label={__('Link')}
							value={ctaLink}
							onChange={(value) =>
								setAttributes({ ctaLink: value })
							}
						/>
						<ToggleControl
							label={__('Open in new Window')}
							checked={ctaTarget}
							onChange={() =>
								setAttributes({ ctaTarget: !ctaTarget })
							}
						/>
					</>
				)}

				{ctaType === 'text' && (
					<TabPanel
						className="wpsp-inspect-tabs wpsp-inspect-tabs-col-2"
						activeClass="active-tab"
						tabs={[
							{
								name: 'normal',
								title: __('Normal'),
								className: 'wpsp-normal-tab',
							},
							{
								name: 'hover',
								title: __('Hover'),
								className: 'wpsp-focus-tab',
							},
						]}
					>
						{(tabName) => {
							let tabout1;
							if ('normal' === tabName.name) {
								tabout1 = (
									<>
										<p className="wpsp-setting-label">
											{__('Text Color')}
											<span className="components-base-control__label">
												<span
													className="component-color-indicator"
													style={{
														backgroundColor:
															ctaLinkColor,
													}}
												></span>
											</span>
										</p>
										<ColorPalette
											value={ctaLinkColor}
											onChange={(colorValue) =>
												setAttributes({
													ctaLinkColor: colorValue,
												})
											}
											allowReset
										/>
									</>
								);
							} else {
								tabout1 = (
									<>
										<p className="wpsp-setting-label">
											{__('Text Hover Color')}
											<span className="components-base-control__label">
												<span
													className="component-color-indicator"
													style={{
														backgroundColor:
															ctaLinkHoverColor,
													}}
												></span>
											</span>
										</p>
										<ColorPalette
											value={ctaLinkHoverColor}
											onChange={(colorValue) =>
												setAttributes({
													ctaLinkHoverColor:
														colorValue,
												})
											}
											allowReset
										/>
									</>
								);
							}
							return <div>{tabout1}</div>;
						}}
					</TabPanel>
				)}
			</PanelBody>
		);
	};

	// Typography settings.
	const TypographySettings = () => {
		return (
			<PanelBody title={__('Content')} initialOpen={false}>
				<ToggleControl
					label={__('Enable Title')}
					checked={showTitle}
					onChange={() => setAttributes({ showTitle: !showTitle })}
				/>
				{showTitle && (
					<>
						<SelectControl
							label={__('Title Tag')}
							value={headingTag}
							onChange={(value) =>
								setAttributes({ headingTag: value })
							}
							options={[
								{ value: 'h1', label: __('H1') },
								{ value: 'h2', label: __('H2') },
								{ value: 'h3', label: __('H3') },
								{ value: 'h4', label: __('H4') },
								{ value: 'h5', label: __('H5') },
								{ value: 'h6', label: __('H6') },
							]}
						/>
						<TypographyControl
							label={__('Typography')}
							attributes={attributes}
							setAttributes={setAttributes}
							loadGoogleFonts={{
								value: headLoadGoogleFonts,
								label: 'headLoadGoogleFonts',
							}}
							fontFamily={{
								value: headFontFamily,
								label: 'headFontFamily',
							}}
							fontWeight={{
								value: headFontWeight,
								label: 'headFontWeight',
							}}
							fontSubset={{
								value: headFontSubset,
								label: 'headFontSubset',
							}}
							fontSizeType={{
								value: headFontSizeType,
								label: 'headFontSizeType',
							}}
							fontSize={{
								value: headFontSize,
								label: 'headFontSize',
							}}
							fontSizeMobile={{
								value: headFontSizeMobile,
								label: 'headFontSizeMobile',
							}}
							fontSizeTablet={{
								value: headFontSizeTablet,
								label: 'headFontSizeTablet',
							}}
							lineHeightType={{
								value: headLineHeightType,
								label: 'headLineHeightType',
							}}
							lineHeight={{
								value: headLineHeight,
								label: 'headLineHeight',
							}}
							lineHeightMobile={{
								value: headLineHeightMobile,
								label: 'headLineHeightMobile',
							}}
							lineHeightTablet={{
								value: headLineHeightTablet,
								label: 'headLineHeightTablet',
							}}
						/>
						<p className="wpsp-setting-label">
							{__('Title Color')}
							<span className="components-base-control__label">
								<span
									className="component-color-indicator"
									style={{ backgroundColor: headingColor }}
								></span>
							</span>
						</p>
						<ColorPalette
							value={headingColor}
							onChange={(colorValue) =>
								setAttributes({ headingColor: colorValue })
							}
							allowReset
						/>
						<hr className="wpsp-editor__separator" />
					</>
				)}
				<h2>{__('Description')}</h2>
				{showDesc && (
					<>
						<TypographyControl
							label={__('Typography')}
							attributes={attributes}
							setAttributes={setAttributes}
							loadGoogleFonts={{
								value: subHeadLoadGoogleFonts,
								label: 'subHeadLoadGoogleFonts',
							}}
							fontFamily={{
								value: subHeadFontFamily,
								label: 'subHeadFontFamily',
							}}
							fontWeight={{
								value: subHeadFontWeight,
								label: 'subHeadFontWeight',
							}}
							fontSubset={{
								value: subHeadFontSubset,
								label: 'subHeadFontSubset',
							}}
							fontSizeType={{
								value: subHeadFontSizeType,
								label: 'subHeadFontSizeType',
							}}
							fontSize={{
								value: subHeadFontSize,
								label: 'subHeadFontSize',
							}}
							fontSizeMobile={{
								value: subHeadFontSizeMobile,
								label: 'subHeadFontSizeMobile',
							}}
							fontSizeTablet={{
								value: subHeadFontSizeTablet,
								label: 'subHeadFontSizeTablet',
							}}
							lineHeightType={{
								value: subHeadLineHeightType,
								label: 'subHeadLineHeightType',
							}}
							lineHeight={{
								value: subHeadLineHeight,
								label: 'subHeadLineHeight',
							}}
							lineHeightMobile={{
								value: subHeadLineHeightMobile,
								label: 'subHeadLineHeightMobile',
							}}
							lineHeightTablet={{
								value: subHeadLineHeightTablet,
								label: 'subHeadLineHeightTablet',
							}}
						/>
						<p className="wpsp-setting-label">
							{__('Description Color')}
							<span className="components-base-control__label">
								<span
									className="component-color-indicator"
									style={{ backgroundColor: subHeadingColor }}
								></span>
							</span>
						</p>
						<ColorPalette
							value={subHeadingColor}
							onChange={(colorValue) =>
								setAttributes({ subHeadingColor: colorValue })
							}
							allowReset
						/>
					</>
				)}
			</PanelBody>
		);
	};

	// Margin Settings.
	const marginSettings = () => {
		return (
			<PanelBody title={__('Spacing')} initialOpen={false}>
				{showTitle && (
					<RangeControl
						label={__('Title Bottom Margin')}
						value={headSpace}
						onChange={(value) =>
							setAttributes({ headSpace: value })
						}
						min={0}
						max={50}
						beforeIcon=""
						allowReset
					/>
				)}
				{'none' !== seperatorStyle && (
					<RangeControl
						label={__('Separator Bottom Margin')}
						value={seperatorSpace}
						onChange={(value) =>
							setAttributes({ seperatorSpace: value })
						}
						min={0}
						max={50}
						beforeIcon=""
						allowReset
					/>
				)}
				{showDesc && (
					<RangeControl
						label={__('Description Bottom Margin')}
						value={subHeadSpace}
						onChange={(value) =>
							setAttributes({ subHeadSpace: value })
						}
						min={0}
						max={50}
						beforeIcon=""
						allowReset
					/>
				)}
				<hr className="wpsp-editor__separator" />
				<h2>{__('Image Margin (px)')}</h2>
				<RangeControl
					label={WPSPBlockIcons.left_margin}
					className={'wpsp-margin-control'}
					value={iconLeftMargin}
					onChange={(value) =>
						setAttributes({ iconLeftMargin: value })
					}
					min={0}
					max={50}
					allowReset
				/>
				<RangeControl
					label={WPSPBlockIcons.right_margin}
					className={'wpsp-margin-control'}
					value={iconRightMargin}
					onChange={(value) =>
						setAttributes({ iconRightMargin: value })
					}
					min={0}
					max={50}
					allowReset
				/>
				<RangeControl
					label={WPSPBlockIcons.top_margin}
					className={'wpsp-margin-control'}
					value={iconTopMargin}
					onChange={(value) =>
						setAttributes({ iconTopMargin: value })
					}
					min={0}
					max={50}
					allowReset
				/>
				<RangeControl
					label={WPSPBlockIcons.bottom_margin}
					className={'wpsp-margin-control'}
					value={iconBottomMargin}
					onChange={(value) =>
						setAttributes({ iconBottomMargin: value })
					}
					min={0}
					max={50}
					allowReset
				/>
			</PanelBody>
		);
	};

	let imageName = __('Select Image');
	if (iconImage) {
		if (iconImage.url === null || iconImage.url === '') {
			imageName = __('Select Image');
		} else {
			imageName = __('Replace Image');
		}
	}

	// Block controls.
	const blockControls = () => {
		return (
			<BlockControls key="controls">
				<AlignmentToolbar
					value={headingAlign}
					onChange={(value) => setAttributes({ headingAlign: value })}
				/>
			</BlockControls>
		);
	};

	// Image controls.
	const imageControls = () => {
		return (
			<>
				{iconImage && iconImage.url !== 'null' && iconImage.url !== '' && (
					<>
						<ToggleControl
							label={__('Custom Size')}
							checked={imageWidthType}
							onChange={() =>
								setAttributes({
									imageWidthType: !imageWidthType,
								})
							}
							help={__(
								'Turn this ON to apply the custom size to image.'
							)}
						/>
						{imageWidthType && (
							<RangeControl
								label={__('Size (px)')}
								value={imageWidth}
								onChange={(value) =>
									setAttributes({ imageWidth: value })
								}
								min={0}
								max={500}
								beforeIcon=""
								allowReset
							/>
						)}
						<RangeControl
							label={__('Rounded Corners (px)')}
							value={iconimgBorderRadius}
							onChange={(value) =>
								setAttributes({ iconimgBorderRadius: value })
							}
							min={0}
							max={500}
							beforeIcon=""
							allowReset
						/>
					</>
				)}
			</>
		);
	};

	// Global Controls.
	const inspectControl = () => {
		return (
			<InspectorControls>
				<PanelBody title={__('Image')}>
					<SelectControl
						label={__('Select Position')}
						value={iconimgPosition}
						onChange={(value) =>
							setAttributes({ iconimgPosition: value })
						}
						options={[
							{ value: 'above-title', label: __('Above Title') },
							{ value: 'below-title', label: __('Below Title') },
							{
								value: 'below-desc',
								label: __('Below Description'),
							},
						]}
					/>

					{sourceType && sourceType === 'image' && imageControls()}
				</PanelBody>
				{TypographySettings()}
				{seperatorSettings()}
				{ctaSettings()}
				{marginSettings()}
			</InspectorControls>
		);
	};
	return (
		<>
			{(iconimgPosition === 'above-title' ||
				iconimgPosition === 'below-title' ||
				iconimgPosition === 'below-desc') &&
				blockControls()}
			<InspectorControls>{inspectControl()}</InspectorControls>
			{loadSubHeadGoogleFonts}
			{loadCtaGoogleFonts}
			{loadHeadGoogleFonts}
		</>
	);
};
export default Settings;
